<template>
  <div v-loading="loading" class="overview-container">
    <div class="project-card-wrapper">
      <el-card
          v-for="card in showProjectCards"
          :key="card.sys.webUrl"
          class="project-card">
        <div class="card-header">
          <div class="card-title">
            <h3>{{ card.sys.name }}</h3>
          </div>
          <a
              v-if="card.data && card.data.length === 10"
              class="more-link"
              @click="toProject(card.sys)">
            查看更多
          </a>
        </div>
        <div v-if="card.data && card.data.length > 0" class="project-list">
          <li
              v-for="item in card.data"
              :key="item.id || item.projectId"
              class="project-item">
            <span @click="getProjectInfo(item, card.sys)">
              {{ getCon(card.sys, item) }}
            </span>
          </li>
        </div>

        <div v-else class="empty-state">
          <i class="el-icon-document"></i>
          <span>暂无项目</span>
        </div>
      </el-card>
    </div>

    <Vx />
    <el-divider class="divider" />

    <div class="footer">
      <div class="footer-content">
        <p><i class="el-icon-phone"></i> 联系方式：021-31021022；13032137192</p>
        <p>
          <i class="el-icon-link"></i> 凌波微课：
          <el-link :underline="false" href="http://www.biomicroclass.com/" target="_blank">
            http://www.biomicroclass.com/
          </el-link>
        </p>
        <p>
          <i class="el-icon-s-promotion"></i> 公司官网：
          <el-link :underline="false" href="http://www.biozeron.com/" target="_blank">http://www.biozeron.com/</el-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getDataInLocalStorage } from '@/utils/localStorage'
import Vx from '@/components/overView/Vx'
import {projectLast_10_raw} from '@/api/rawData'
import {projectLast_10_bz, projectLast_10_bz_fun} from '@/api/bz'
import { projectLast_10_metag } from '@/api/metag'
import { modelInfo } from '@/utils/data/basicData/projectData'
import { projectLast_10_trans } from '@/api/trans'
import { projectLast_10_naked } from '@/api/naked/rawData/project'
import { projectLast_10_metabo } from '@/api/metabo'
import { projectDetailsUrl, projectLast_10_singleCell } from '@/api/singleCell'
import {projectLast_10_transMetabo} from "@/api/transMetabo";
import {projectLast_10_bzMetabo} from "@/api/bzMetabo";
import {projectLast_10_eDNA} from "@/api/eDNA";

export default {
  name: 'OverView',
  components: { Vx },
  data() {
    return {
      loading: true,
      userData: '',
      projectCards: [],
      projectSys: []
    }
  },
  computed: {
    // 按 webUrl 把数据与系统配置打包后的卡片，过滤掉无对应系统或被 condition 隐藏的
    showProjectCards() {
      return this.projectCards.filter(card => card.sys && this.getCondition(card.sys))
    }
  },
  created() {
    this.initUserData()
    this.initProjectSys()
    this.getProjectLast_10()
    this.checkUserPassword()
  },
  methods: {
    initUserData() {
      this.userData = JSON.parse(getDataInLocalStorage('user'))
    },
    initProjectSys() {
      this.projectSys = modelInfo.filter(
          item => item.isOverview && (!item.condition || eval(item.condition))
      )
    },
    checkUserPassword() {
      if (!this.userData.initialized) {
        this.$confirmUi('该账号还未设置密码，是否立即设置密码？', '提示', {
          confirmButtonText: '设置密码',
          cancelButtonText: '暂不',
          type: 'warning'
        }).then(() => {
          this.$router.push('/info')
        }).catch(() => {})
      }
    },
    getCondition(datas) {
      if (!datas) return false
      return datas?.isOverview && (!datas?.condition || eval(datas?.condition))
    },
    async getProjectLast_10() {
      // 每个请求显式声明其对应的系统 webUrl，作为与 projectSys 关联的键
      const requestList = [
        { webUrl: '/projectBz', request: projectLast_10_bz },
        { webUrl: '/projectBzFun', request: projectLast_10_bz_fun },
        { webUrl: '/projectMetag', request: projectLast_10_metag },
        { webUrl: '/projectTrans', request: projectLast_10_trans },
        { webUrl: '/projectMetabo', request: projectLast_10_metabo },
        { webUrl: '/projectSingleCell', request: projectLast_10_singleCell },
        { webUrl: '/projectTransMetabo', request: projectLast_10_transMetabo },
        { webUrl: '/projectBzMetabo', request: projectLast_10_bzMetabo },
        { webUrl: '/projectEDNA', request: projectLast_10_eDNA },
        { webUrl: '/nakedRawData', request: projectLast_10_naked },
        { webUrl: '/projectRawData', request: projectLast_10_raw }
      ]
      try {
        const allRes = await Promise.all(requestList.map(item => item.request()))
        this.projectCards = allRes.map((res, index) => {
          const sys = this.projectSys.find(item => item.webUrl === requestList[index].webUrl)
          return { sys, data: res.data }
        })
      } catch (error) {
        console.error('获取项目数据失败：', error)
      } finally {
        this.loading = false
      }
    },
    async getProjectInfo(item, sys) {
      const { getRole } = this.$store.getters["right/getRole"]
      if (['USER', 'SALES'].includes(getRole)) {
        const noRelease = !(item?.bsReleased && item?.resReleased)
        if (noRelease && sys.webUrl !== '/nakedRawData') {
          this.$messageUi.error('分析结果未释放，不可查看')
          return
        }
      }

      if (sys.webUrl === '/projectSingleCell' && item.platformAttribute.status !== 'SUCCESS') {
        this.$messageUi.error('分析结果未完成，不可查看')
        return
      }

      const url = await this.getProjectUrl(sys, item)
      url && window.open(url)
    },
    async getProjectUrl(sys, item) {

      let url = ''
      switch (sys.webUrl) {
        case '/projectRawData':
          url = `/raw/data/info?id=${item.id}`
          break
        case '/projectBz':
          url = `/bzWeb/desc?projectId=${item.projectId}`
          break
        case '/projectBzFun':
          url = `/bzWeb/desc?projectId=${item.projectId}`
          break
        case '/projectMetag':
          url = item?.version?.value === 'v3'
              ? `/metagWeb_v3/desc?projectId=${item.projectId}`
              : `/metagWeb/desc?projectId=${item.projectId}`
          break
        case '/projectTrans':
          url = `/transWeb/desc?projectId=${item.projectId}`
          break
        case '/projectMetabo':
          url = `/metaboWeb/desc?projectId=${item.projectId}`
          break
        case '/projectTransMetabo':
          url = `/transMetaboWeb/desc?projectId=${item.projectId}`
          break
        case '/projectBzMetabo':
          url = `/ampMetaboWeb/desc?projectId=${item.projectId}`
          break
        case '/nakedRawData':
          url = `/nakedRawData?id=${item.id}`
          break
        case '/projectSingleCell':
          const res = await projectDetailsUrl(item.id)
          url = res?.code === 200 ? res.data : ''
          break;
        case '/projectEDNA':
          url = `/eDNAWeb/desc?projectId=${item.projectId}`
          break

      }
      return url
    },
    getCon(project, item) {
      if (project.name === '宏基因组系统') {
        return `${item.contractNumber} --- ${item.projectType} - ${item.projectSign}`
      }
      if(['转录和代谢联合分析交付系统','多样性和代谢联合分析交付系统'].includes(project.name)){
        return `${item.projectId} `
      }
      const contract = item.contractNumber || item.contractNo
      return `${contract} --- ${item.projectType}`
    },
    toProject(sys) {
      this.$router.push(sys.webUrl)
    }
  }
}
</script>

<style scoped>
.overview-container {
  margin: auto;
  //padding: 0px 20px;
  min-height: calc(100vh - 70px);
}

.project-card-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(335px, 1fr));
  gap: 40px;
}

.project-card {
  margin: 0 auto;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(94, 191, 200, 0.10);
  transition: all 0.3s ease;
  border: 1px solid #e8f4f5;
}

.project-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(94, 191, 200, 0.18);
  //border-color: #5ebfc8;
}

.project-card >>> .el-card__body {
  padding: 22px 20px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.card-title {
  font-weight: 600;
  color: #303133;
  border-left: 4px solid #5ebfc8;
  line-height: 20px;
  padding-left: 10px;
}

.card-title h3 {
  margin: 0;
  font-size: 16px;
}

.more-link {
  font-size: 13px;
  color: #177bd3;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
}

.more-link:hover {
  color: #205998;
  text-decoration: underline;
}

.project-list {
  font-size: 14px;
  margin-top: 6px;
  padding: 0;
}

.project-item {
  cursor: pointer;
  color: #606266;
  padding: 6px 0;
  list-style: none;
  transition: color 0.2s;
  border-bottom: 1px dashed #f0f0f0;
 //list-style:square ;
}

.project-item:last-child {
  border-bottom: none;
}

.project-item::before {
  content: '';
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #4cb1bb;
  margin-right: 8px;
  vertical-align: middle;
  opacity: 0.7;
}

.project-item:hover {
  color: #177bd3 !important;
}

.project-item:hover::before {
  opacity: 1;
}

.empty-state {
  text-align: center;
  margin: 45px 0;
  color: #c0c4cc;
  font-size: 14px;
}

.empty-state i {
  font-size: 28px;
  margin-bottom: 8px;
  display: block;
  //color: #d9ecee;
}

.divider {
  margin: 24px 0 16px;
}

.footer {
  padding: 14px 0;
  color: #909399;
  font-size: 13px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.footer p {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.footer i {
  color: #2566a9;
}
</style>
